/**
 * EDUCATION DOMAIN CONFIGURATION
 * Cấu hình cho lĩnh vực Giáo dục
 */
export const domainConfig = {
  // === BASIC INFO ===
  id: "education",
  name: "Giáo dục",
  icon: "🎓",
  description:
    "Tạo nội dung marketing cho trường học, trung tâm đào tạo và dịch vụ giáo dục",

  // === PROJECT TYPES ===
  projectTypes: {
    "Trường học (K12)": 1,
    "Đại học/Cao đẳng": 2,
    "Trung tâm ngoại ngữ": 3,
    "Trung tâm tin học": 4,
    "Kỹ năng mềm": 5,
    "Dạy nghề/Tay nghề": 6,
    "Gia sư/Dạy kèm": 7,
    "Khóa học online": 8,
    "Luyện thi IELTS/TOEIC": 9,
    "Mầm non/Mẫu giáo": 10,
  },

  // === CONTENT TYPES ===
  contentTypes: {
    "Giới thiệu khóa học": 1,
    "Thông tin tuyển sinh": 2,
    "Thành tích học viên": 3,
    "Khuyến mãi học phí": 4,
    "Giới thiệu giảng viên": 5,
    "Phương pháp giảng dạy": 6,
    "Cơ sở vật chất": 7,
    "Event/Hội thảo": 8,
    "Tư vấn định hướng": 9,
    "Testimonial học viên": 10,
    "Tips học tập": 11,
    "Thông tin học bổng": 12,
  },

  // === PUBLISHING PLATFORMS (Optional) ===
  publishingPlatforms: {
    // Để trống sẽ dùng shared platforms
  },

  // === DEFAULT VALUES ===
  defaults: {
    projectType: "Trung tâm ngoại ngữ",
    contentType: "Giới thiệu khóa học",
    postLength: "Trung bình",
    postStyles: ["Chuyên nghiệp", "Thân thiện"],
  },

  // === UI LABELS ===
  labels: {
    projectTypeLabel: "Loại hình giáo dục",
    contentTypeLabel: "Loại nội dung",
    projectInfoLabel: "Thông tin khóa học/trường học",
    projectInfoPlaceholder:
      "Nhập thông tin chi tiết về khóa học, chương trình, giảng viên, thời gian...",
    targetCustomerLabel: "Đối tượng học viên",
    targetCustomerPlaceholder:
      "Mô tả đối tượng học viên: độ tuổi, trình độ, mục tiêu học tập...",
  },

  // === DOMAIN-SPECIFIC SETTINGS ===
  settings: {
    requiresLocation: true, // Quan trọng cho địa điểm học
    requiresPrice: true, // Học phí quan trọng
    requiresDuration: true, // Thời gian khóa học
    requiresSchedule: true, // Lịch học
  },
};
